import "./Navbar.css";
import { Link, useLocation } from "react-router-dom";

function Navbar() {
    const location = useLocation();

    let pageTitle = "Home";
    if (location.pathname === "/about") {
        pageTitle = "About";
    }
    else if (location.pathname === "/contact") {
        pageTitle = "Contact";
    }
    
    return (
        <div className="navbar">
            <div className="navbar-title">
                {pageTitle}
            </div>

            <nav className="navbar-content">
                <Link to="/" className="nav-link">Home</Link>
                <Link to="/contact" className="nav-link">Contact</Link>
                <Link to="/about" className="nav-link">About</Link>
            </nav>
        </div>
    );
}

export default Navbar;  